import { useState, useEffect, useMemo } from 'react';
import { getApp } from 'firebase/app';
import { getFirestore, collection, onSnapshot } from 'firebase/firestore';
import { membersForPortal } from '../utils/viewAs';

let _db = null;
const db = () => {
  if (!_db) {
    try { _db = getFirestore(getApp()); } catch (_) {}
  }
  return _db;
};

export function useViewAsMembers(portalId) {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    const firestore = db();
    if (!firestore || !portalId) {
      setMembers([]);
      return undefined;
    }
    return onSnapshot(
      collection(firestore, 'authorized_users'),
      snap => setMembers(snap.docs.map(d => ({ uid: d.id, ...d.data() }))),
      () => setMembers([]),
    );
  }, [portalId]);

  return useMemo(() => membersForPortal(members, portalId), [members, portalId]);
}
